import { render, staticRenderFns } from "./FatalError.vue?vue&type=template&id=43d18a7c&scoped=true&"
import script from "./FatalError.vue?vue&type=script&lang=js&"
export * from "./FatalError.vue?vue&type=script&lang=js&"
import style0 from "./FatalError.vue?vue&type=style&index=0&id=43d18a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d18a7c",
  null
  
)

export default component.exports